export default "__VITE_ASSET__DkFvnT4P__"